import Color from 'color';
import { lFColor0 } from 'pages/components/LFHeader/LFHeader.styled';
import { leftSidePanelMotionEase } from 'pages/styles';
import styled, { keyframes } from 'styled-components';

const ink = '#1a1a1a';
const inkBody = '#4a4a4a';
const line = Color('#e5e7eb').darken(0.02).toString();
const rowHover = Color(lFColor0).alpha(0.06).toString();
const chipOnBg = Color(lFColor0).alpha(0.1).toString();
const chipOnBorder = Color(lFColor0).alpha(0.35).toString();

const chipIn = keyframes`
  from { opacity: 0; transform: translateY(4px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  height: 100%;
`;

export const Container2 = styled(Container)``;

export const Chips = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ActivitySet = styled.button<{ $selected?: boolean; $isKey?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  margin: 0;
  padding: 7px 10px;
  border: 1px solid ${({ $selected }) => ($selected ? chipOnBorder : line)};
  border-radius: 8px;
  background: ${({ $selected }) => ($selected ? chipOnBg : '#fff')};
  color: ${({ $selected, $isKey }) => {
    if ($selected) return lFColor0;
    if ($isKey) return ink;
    return inkBody;
  }};
  font-size: 12px;
  font-weight: ${({ $selected, $isKey }) => ($selected || $isKey ? 600 : 500)};
  font-family: inherit;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  animation: ${chipIn} 240ms ${leftSidePanelMotionEase} both;
  transition: background 140ms ease, color 140ms ease, border-color 140ms ease;

  &:hover {
    background: ${({ $selected }) => ($selected ? chipOnBg : rowHover)};
    border-color: ${({ $selected }) => (
      $selected ? chipOnBorder : Color(lFColor0).alpha(0.28).toString()
    )};
    color: ${lFColor0};
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ActivityName1 = styled.span`
  min-width: 0;
`;

export const Select = styled.span<{ $checked?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  border-radius: 3px;
  border: 1.5px solid ${({ $checked }) => (
    $checked ? lFColor0 : Color(line).darken(0.08).toString()
  )};
  background: ${({ $checked }) => ($checked ? lFColor0 : '#fff')};
  color: #fff;

  & > svg {
    font-size: 11px;
  }
`;

export const OptionButton = styled.button<{ $light?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0;
  padding: 8px 14px;
  border: ${({ $light }) => (
    $light ? `1px solid ${chipOnBorder}` : 'none'
  )};
  border-radius: 8px;
  background: ${({ $light }) => ($light ? chipOnBg : lFColor0)};
  color: ${({ $light }) => ($light ? lFColor0 : '#fff')};
  font-size: 12px;
  font-weight: 600;
  font-family: inherit;
  line-height: 1.2;
  white-space: nowrap;
  cursor: pointer;
  transition: background 140ms ease, border-color 140ms ease, transform 140ms ease;

  &:hover {
    background: ${({ $light }) => (
      $light
        ? Color(lFColor0).alpha(0.16).toString()
        : Color(lFColor0).darken(0.08).toString()
    )};
    border-color: ${({ $light }) => (
      $light ? Color(lFColor0).alpha(0.45).toString() : 'transparent'
    )};
  }

  &:active {
    transform: scale(0.98);
  }
`;
